import { LoggedInUserRegex } from '../components/TemplatePage/Modals/SelfHostedModal/consts';

export const getIsLoggedInByCookie = () =>
  !!document.cookie.match(LoggedInUserRegex);
